import { API_LOG_URL, EVENT_LOG_URL, PAGE_LOG_URL } from '../../constants';
import { http } from '../../utils';

export const sendApiLog = async (response, params) => {
  try {
    if (!response || !response.config || !response.config.url || response.config.url.indexOf('wlog') !== -1) {
      return;
    }

    await http.post(API_LOG_URL, params);
  } catch {
    // TODO: error 발생 시 어떤 방식으로 처리할 지 추후 논의 예정
  }
};

export const sendEventLog = (data, user = { user_id: '', role: '', grade: 0 }) => {
  const params = {
    id: user.user_id,
    role: user.role,
    grade: user.grade,
    client_time: new Date().getTime(),
    device: 'web.event',
    app_version: navigator.appVersion,
    os_version: null,
    ip: null,
    language: navigator.language,
    country: navigator.language,
    ...data,
  };

  return http.post(EVENT_LOG_URL, params)
    .catch(() => {
      // TODO: error 발생 시 어떤 방식으로 처리할 지 추후 논의 예정
    });
};

export const sendPageLog = (params) => (
  http.post(PAGE_LOG_URL, params)
    .catch(() => {
      // TODO: error 발생 시 어떤 방식으로 처리할 지 추후 논의 예정
    })
);
